import React from "react";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import "./FAQ.css";

interface FAQItemProps {
  id: string;
  question: string;
  answer: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}

const FAQItem: React.FC<FAQItemProps> = ({
  id,
  question,
  answer,
  isOpen,
  onClick,
}) => {
  return (
    <div className={`faq-item ${isOpen ? "open" : ""}`} id={id}>
      <div className="faq-question" onClick={onClick}>
        {question}
        <span className="faq-icon">
          {isOpen ? <FiChevronUp /> : <FiChevronDown />}
        </span>
      </div>
      <div className="faq-answer">{answer}</div>
    </div>
  );
};

export default FAQItem;
